var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "90", height: "52", viewBox: "0 0 90 52", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "Symbols", fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M87.87 1.168c-2.42-1.862-5.926-1.453-7.83.914L50.536 38.758l-7.845-6.77 18.63-23.16c1.905-2.367 1.486-5.797-.934-7.66-2.42-1.862-5.927-1.454-7.831.914L23.052 38.758 9.427 26.043c-2.229-2.08-5.757-1.998-7.885.18a5.372 5.372 0 0 0 .184 7.712L19.283 50.32a6.305 6.305 0 0 0 4.732 1.664 6.266 6.266 0 0 0 4.44-2.304l7.302-9.077 11.01 9.717a6.305 6.305 0 0 0 4.732 1.664 6.266 6.266 0 0 0 4.44-2.304L88.805 8.827c1.905-2.368 1.488-5.796-.934-7.659", id: "Fill-1", fill: "#34F", fillRule: "nonzero" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/ReadReceiptRateCard/svgs/read_receipts_big.svg